var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtandIllustration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-bb22b7c8-a4af-4ed9-8a64-7b7efa8e02e1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.2,
    height: 73.2,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 67.2 73.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-25900fc7-413b-4e84-bbba-dd29d0a2f5ee{fill:url(#uuid-567dec64-aaf3-4b8f-9065-0d4da7f2ac0d);}.uuid-bde32d14-df00-4dff-a47d-e75a050fb81e{fill:url(#uuid-c22942ed-d9a7-42c7-a510-5455a79b7a89);}.uuid-e2bf9cf0-29eb-46ff-9bc3-f2c67fdd2a84{fill:url(#uuid-a9128e69-ed89-4ed3-9a21-538411f68da3);}.uuid-188423a4-6077-4706-8839-453f936fc847{fill:url(#uuid-e499e2d7-855e-4b4a-aa05-60d17f71ce6e);}.uuid-9566493d-9a53-456b-b0da-fb3221808e08{fill:url(#uuid-f3a1db46-4a6b-437b-bfac-db30507f2e9c);}.uuid-106aa8b9-02b2-42a8-b0bf-4991793e1ca8{fill:url(#uuid-d02513db-563c-49d3-9364-987a64cd6ff2);}.uuid-7c28e144-ac5c-4d60-8ec8-536f1dadc472{fill:url(#uuid-0f834ec4-74ec-46e6-9b2c-5d1bd84051aa);}.uuid-7eb793b7-33c1-4cba-8272-bc290752808b{fill:url(#uuid-bf3f95ba-6898-49fe-93fa-adeba0aa4294);}.uuid-b34f7937-7384-4db7-acf9-feaf70454b0c{fill:url(#uuid-c2615714-d67b-4597-8d2e-198345f0e6f0);}.uuid-33f99234-4a54-446e-a5d3-e7375932db7a{fill:url(#uuid-86d4de2d-09b0-4c70-af35-a9cbd59d00bd);}.uuid-c745f0ab-3a98-440c-a683-7cb79d74394f{fill:url(#uuid-57b030c0-c979-47ba-a4ed-59a7ddbc70ae);}.uuid-059ed1d9-bdae-4ed4-88a3-ae41d975cc3c{fill:url(#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4);}.uuid-0c8c157d-ce56-4f99-a43e-aef988285fc4{fill:url(#uuid-c2ed97cb-fbc1-4ab9-b94d-955696a5c938);}.uuid-10a73258-05ef-42c9-a530-54ab6e60af0c{fill:url(#uuid-18963e99-ef8b-4375-827d-36e121bb310b);}.uuid-1b4efc57-1d6f-4619-9911-e4aba22bf88a{fill:url(#uuid-d67d100e-735a-4a21-8eb3-2154a3f96aaa);}.uuid-81b53b9c-db86-4995-8d02-1a161cf5b03b{fill:url(#uuid-b1886b88-171a-4723-ab6a-31862a70b9cb);}.uuid-8bc3196a-45ec-49e3-981d-cadad2686eb6{fill:url(#uuid-5c9cf17b-7305-46e4-9438-ebf4f159e27c);}.uuid-753e0140-739b-46a2-9323-b3076c1aea73{fill:url(#uuid-dcdba9db-767e-4607-a94e-becc2bc82494);}.uuid-c1da040c-4699-43b4-85d0-85d906f35b32{fill:url(#uuid-01b5c906-4d85-405e-9129-4be1abe32ed9);}.uuid-09aadaa6-0025-405c-9311-4051b063a049{fill:url(#uuid-0adefdf8-704a-464d-a16c-298e37503913);}.uuid-750c8bb0-8718-455c-9ec3-de48b119f7e3{fill:url(#uuid-415a07f0-a499-4b29-a8d3-984291e818ab);}.uuid-1ea5eafc-affa-42c0-a263-415ee0cb447e{fill:url(#uuid-b7f740e4-ea44-44ab-a659-d55e68dd92ec);}.uuid-4d517895-a005-407d-b031-03cdfe8d77ea{fill:url(#uuid-d2387a3c-a3b6-4691-a650-d2b914f53876);}.uuid-ecd6b603-5ba2-40b4-b864-43b7b343af87{fill:url(#uuid-58938534-438d-4966-8a7b-7673814dca03);}.uuid-0085a2e1-3cba-4fd8-89ca-050f88866145{fill:url(#uuid-03e1c98e-cf4a-4ebf-ae1b-741dc31b7643);}.uuid-d6107f35-9b6f-4976-8a28-05ee50f5a365{fill:url(#uuid-1653461a-f61b-46f4-aeab-684b562c22a4);}.uuid-1c9d4609-ddfc-4904-adbf-30fa9dfc99ed{fill:url(#uuid-a57acb94-6175-4214-8581-fbfb83b82660);}.uuid-94ab15b2-2604-40b1-88d2-ba4ff9d4c9fa{fill:url(#uuid-ac27cd17-eac8-4ecb-9aa8-fcb9d2b80b80);}.uuid-c3cf1b5a-4c58-4190-9cca-6e5fb3b59ed9{fill:url(#uuid-defc0024-39ed-4aa2-a835-09f397027385);}.uuid-d269df1b-517b-4558-b8d2-ef1165d0c70c{fill:url(#uuid-bc9f2073-c2f8-462a-a5a9-8ce52cf9f98b);}.uuid-4171c1f7-8cd5-4339-9dda-80061ccc48fb{fill:url(#uuid-ab50e892-c3e2-404e-b43f-1bf9517a9c3b);}.uuid-ed97a815-df58-4080-a3f2-8c8059874e17{fill:url(#uuid-66f25f32-d0ff-4e59-89c8-53ecfdac8abe);}.uuid-2d89ed8f-58d6-4899-871e-3af2f7da0362{fill:url(#uuid-1bd79008-0eea-4750-ba2e-b1d2dc5be309);}.uuid-f5688104-de39-4646-842d-8c80c3698a0e{fill:url(#uuid-85c98f36-a79f-4d0d-88dd-4f78e44a2f95);}.uuid-2244b5c5-2494-43b9-941d-814a3dfba9e1{fill:url(#uuid-3d72403a-ac98-43f4-8c11-38cc6d80d342);}.uuid-aa4dcba3-4355-4d66-9aca-7d2d3bd710be{fill:url(#uuid-36e2cce4-ee2f-4ad7-8cef-54d31e307404);}.uuid-daf4052d-cedd-49f1-9ab3-22dfa1f58875{fill:url(#uuid-54c187bf-6a82-4d45-acd8-ec0991f3dce9);}.uuid-09d1b8f9-f58a-4355-91b8-2269bf791e46{fill:url(#uuid-a172a32a-8fe4-45e2-acd3-bbc533558d78);}.uuid-30a81f88-b04b-46b3-91d0-ceba4cc92336{fill:url(#uuid-999021e9-49e2-4bed-8a31-6dcf8494eed2);}.uuid-f3767eb2-330f-4c68-941a-4f9ac1c3f136{fill:url(#uuid-ea66d447-0ff8-47fc-b75b-17b2af22efb0);}.uuid-79eec3e5-e4b1-4fb0-8514-0b804447255c{fill:url(#uuid-0d680a91-74f1-4dcd-83bb-da5ed4d0d3bc);}.uuid-26a16ce9-aca4-4b3f-80d8-2587efb72666{fill:url(#uuid-63fe9b69-fe89-4833-8de7-f43e7f70081d);}.uuid-cca3c92e-d836-43c1-b330-4c6ca7b1e8bb{fill:url(#uuid-5c632756-924f-40a4-93b7-4a277a904180);}.uuid-7e8b2f09-ac07-4805-b984-f85d2a7afe29{fill:url(#uuid-157b7737-0f2f-4465-b96e-780f27f5385d);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4",
    x1: 2.1,
    y1: 51.3,
    x2: 57.2,
    y2: 51.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f37525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fab73d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-57b030c0-c979-47ba-a4ed-59a7ddbc70ae",
    x1: 37.5,
    y1: 36.9,
    x2: 65.9,
    y2: 36.9,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-0d680a91-74f1-4dcd-83bb-da5ed4d0d3bc",
    x1: 27.5,
    y1: 12.3,
    x2: 40.4,
    y2: 12.3,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-567dec64-aaf3-4b8f-9065-0d4da7f2ac0d",
    x1: 5.1,
    y1: 16.9,
    x2: 20.4,
    y2: 16.9,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-ac27cd17-eac8-4ecb-9aa8-fcb9d2b80b80",
    x1: 55.4,
    y1: 21.6,
    x2: 66.3,
    y2: 21.6,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-58938534-438d-4966-8a7b-7673814dca03",
    x1: 3.3,
    y1: 38.9,
    x2: 11.5,
    y2: 38.9,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-c2ed97cb-fbc1-4ab9-b94d-955696a5c938",
    x1: 15.3,
    y1: 25.5,
    x2: 26.8,
    y2: 25.5,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-0adefdf8-704a-464d-a16c-298e37503913",
    x1: 0,
    y1: 34.7,
    x2: 4.9,
    y2: 34.7,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-ea66d447-0ff8-47fc-b75b-17b2af22efb0",
    x1: 54.9,
    y1: 6.4,
    x2: 64.6,
    y2: 6.4,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-5c9cf17b-7305-46e4-9438-ebf4f159e27c",
    x1: 0,
    y1: 28.8,
    x2: 11.6,
    y2: 28.8,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-3d72403a-ac98-43f4-8c11-38cc6d80d342",
    x1: 45.8,
    y1: 28.2,
    x2: 55.9,
    y2: 28.2,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-c2615714-d67b-4597-8d2e-198345f0e6f0",
    x1: 17.2,
    y1: 38.8,
    x2: 20.8,
    y2: 38.8,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-defc0024-39ed-4aa2-a835-09f397027385",
    x1: 55.3,
    y1: 36.2,
    x2: 67.2,
    y2: 36.2,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-157b7737-0f2f-4465-b96e-780f27f5385d",
    x1: 17.4,
    y1: 62.3,
    x2: 23.1,
    y2: 62.3,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-c22942ed-d9a7-42c7-a510-5455a79b7a89",
    x1: 4.3,
    y1: 48.7,
    x2: 7.9,
    y2: 48.7,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-999021e9-49e2-4bed-8a31-6dcf8494eed2",
    x1: 10.9,
    y1: 8.9,
    x2: 13.5,
    y2: 8.9,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-e499e2d7-855e-4b4a-aa05-60d17f71ce6e",
    x1: 31.7,
    y1: 21.6,
    x2: 36.3,
    y2: 21.6,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-bf3f95ba-6898-49fe-93fa-adeba0aa4294",
    x1: 31.7,
    y1: 23.2,
    x2: 36.3,
    y2: 23.2,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-0f834ec4-74ec-46e6-9b2c-5d1bd84051aa",
    x1: 32.3,
    y1: 24.8,
    x2: 35.7,
    y2: 24.8,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-54c187bf-6a82-4d45-acd8-ec0991f3dce9",
    x1: 20.2,
    y1: 34.4,
    x2: 24.2,
    y2: 34.4,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-dcdba9db-767e-4607-a94e-becc2bc82494",
    x1: 10.8,
    y1: 41.3,
    x2: 17.2,
    y2: 41.3,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-1653461a-f61b-46f4-aeab-684b562c22a4",
    x1: 31.6,
    y1: 11.4,
    x2: 33.3,
    y2: 11.4,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-36e2cce4-ee2f-4ad7-8cef-54d31e307404",
    x1: 34.7,
    y1: 11.4,
    x2: 36.4,
    y2: 11.4,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-415a07f0-a499-4b29-a8d3-984291e818ab",
    x1: 14.3,
    y1: 55.7,
    x2: 17.9,
    y2: 55.7,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-a57acb94-6175-4214-8581-fbfb83b82660",
    x1: 0.2,
    y1: 22.7,
    x2: 5.9,
    y2: 22.7,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-d02513db-563c-49d3-9364-987a64cd6ff2",
    x1: 39.8,
    y1: 4.4,
    x2: 41.7,
    y2: 4.4,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-5c632756-924f-40a4-93b7-4a277a904180",
    x1: 29.3,
    y1: 2.1,
    x2: 30.7,
    y2: 2.1,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-01b5c906-4d85-405e-9129-4be1abe32ed9",
    x1: 26.1,
    y1: 4.4,
    x2: 28.1,
    y2: 4.4,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-bc9f2073-c2f8-462a-a5a9-8ce52cf9f98b",
    x1: 37.2,
    y1: 2.1,
    x2: 38.6,
    y2: 2.1,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-63fe9b69-fe89-4833-8de7-f43e7f70081d",
    x1: 33.7,
    y1: 1.2,
    x2: 34.2,
    y2: 1.2,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-86d4de2d-09b0-4c70-af35-a9cbd59d00bd",
    x1: 24.2,
    y1: 7.3,
    x2: 26.4,
    y2: 7.3,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-a9128e69-ed89-4ed3-9a21-538411f68da3",
    x1: 41.4,
    y1: 14,
    x2: 43.4,
    y2: 14,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-ab50e892-c3e2-404e-b43f-1bf9517a9c3b",
    x1: 24.4,
    y1: 14,
    x2: 26.4,
    y2: 14,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-f3a1db46-4a6b-437b-bfac-db30507f2e9c",
    x1: 41.4,
    y1: 7.3,
    x2: 43.5,
    y2: 7.3,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-1bd79008-0eea-4750-ba2e-b1d2dc5be309",
    x1: 23.6,
    y1: 10.6,
    x2: 25.9,
    y2: 10.6,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-66f25f32-d0ff-4e59-89c8-53ecfdac8abe",
    x1: 41.9,
    y1: 10.6,
    x2: 44.2,
    y2: 10.6,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-85c98f36-a79f-4d0d-88dd-4f78e44a2f95",
    x1: 18.1,
    y1: 63.5,
    x2: 22.4,
    y2: 63.5,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-18963e99-ef8b-4375-827d-36e121bb310b",
    x1: 61.3,
    y1: 50.9,
    x2: 62.8,
    y2: 50.9,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-03e1c98e-cf4a-4ebf-ae1b-741dc31b7643",
    x1: 11.5,
    y1: 67.1,
    x2: 12.3,
    y2: 67.1,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-d2387a3c-a3b6-4691-a650-d2b914f53876",
    x1: 5.2,
    y1: 9,
    x2: 6.1,
    y2: 9,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-d67d100e-735a-4a21-8eb3-2154a3f96aaa",
    x1: 55.4,
    y1: 25.2,
    x2: 56.4,
    y2: 25.2,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-a172a32a-8fe4-45e2-acd3-bbc533558d78",
    x1: 7,
    y1: 9,
    x2: 10.6,
    y2: 9,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-b1886b88-171a-4723-ab6a-31862a70b9cb",
    x1: 54.4,
    y1: 11.1,
    x2: 55.3,
    y2: 11.1,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-b7f740e4-ea44-44ab-a659-d55e68dd92ec",
    x1: 54.2,
    y1: 11.6,
    x2: 54.8,
    y2: 11.6,
    xlinkHref: "#uuid-a1c1d6e1-3940-44cf-8b8a-3f0fa34b26e4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-2e2851a6-3556-4a83-b686-93489c121f41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-059ed1d9-bdae-4ed4-88a3-ae41d975cc3c",
    d: "M17.7,54.3c-.4-.5,0-1.1,0-1.6,0-.3.1-.5.3-.8-.7,0-1.3,0-1.9,0-1.4,0-2.9,0-4.3,0-.3,0-.5,0-.5.5,0,1.4,0,2.9,0,4.3,0,0,0,.1,0,.2,0,.4,0,.9.4,1.1.3.1.5-.4.7-.6.3-.3.6-.5.8-.8.3-.3.5-.3.7,0,.4.4.8.7,1.1,1.1.1.2.2.3,0,.5-.3.3-.6.6-.9,1h13.8c-1.5-4.9-2.9-9.7-4.2-14.6,0-.1,0-.2,0-.3,0-.2-.3-.5.1-.5.3,0,.7-.2.8.4.3,1.2.6,2.3,1,3.4,0-.8,0-1.6,0-2.4-.1-2.8,1-5,2.9-6.9.4-.4.3-.9.7-1.3.2-.2.2-.5.6-.3.2,0,.2,0,.2-.2.4-.8.6-1.6.3-2.5-.2-.7-.2-1.4-.3-2.1,0-.2,0-.6.2-.6.6,0,.9-.8,1.5-.6.3,0,.3,0,.4-.3.4-1.1,1.3-1.3,2.1-.4.2.3.5.4.8.3.7-.1,1.2,0,1.5.7.2.3.3.3.6.4.8.1,1.1.5.8,1.3,0,.2,0,.3,0,.4,0,.1.2.2.3.3.2.4.2.7,0,1.1-.3.4-.6.3-.9.3,0-.3.3-.3.2-.5-.2,0-.4,0-.5.3-.2.7-.6,1.4-.4,2.2,0,.4,0,.6-.5.6-.4,0-.5.5-.8.7-.3.3-.4.8-.8.9-.4.1-.8-.3-1.1-.5-.5-.2-.7.2-1,.4-.3.2,0,.4.1.5.3.3.5.6,0,.9-.3.2-.3.5-.2.8.6,2.8,1.2,5.6,1.7,8.4,0,.5.3.6.7.5,1.1-.2,2.1-.4,3.2-.6.3,0,.7-.3,1,.2,0,0,.2,0,.3,0,0,0,.2,0,.3,0,.9,0,1.4-.5,1.7-1.3.1-.4.3-.9.9-1.2-1-.3-2-.5-3-.8-.7-.2-1.4-.4-2.1-.5-.2,0-.3,0-.3-.3,0-.3.2-.2.4-.2,1.7.4,3.4.8,5.1,1.3.3,0,.6.1.9,0,.6,0,1,.2,1.4.5.6.3,1.3.3,1.9.6.1,0,.2-.1.3-.2.3-.3.7-.7,1-1,.2-.2.3-.2.5,0,.2.2.3.3,0,.6-1.5,1.6-3,3.1-4.5,4.7-.3.4-.7.7-1,1.1.2.2.5.1.7.1.3,0,.6,0,.8.4,1.9,3.5,3.9,7,5.8,10.5.2.3.6.7.3,1.2,0,0,0,.2.2.3,1,1.5,2.6,2.2,4.2,2.7.6.2,1.2.2,1.8.3.3,0,.4.2.5.5,0,.3,0,.4-.3.5-1.9.3-3.7.7-5.6.6-.3,0-.3.3-.5.3-.7,0-1.5.2-2.2.3-.2,0-.4,0-.4-.3,0-.6-.2-1.2-.1-1.8,0-.2,0-.3,0-.5.3-.8.3-1-.2-1.7-.8.3-.8.3-1.2-.5-.3-.5-.5-1-.8-1.5-.3-.5-.5-1-.8-1.6-.1.5,0,.9,0,1.3,0,1.4,0,2.7,0,4.1,0,.2,0,.4-.2.4-.1,0,0,.1,0,.2,0,.7.1,1.3.7,1.9,1.1,1,2.4,1.6,3.8,1.9.3,0,.7,0,.7.5,0,.2.2.1.4.1.9,0,1.7,0,2.6,0,.4,0,.7.2,1,.1-12.7.2-25.3,0-38,0,.5-.3,1-.1,1.4-.2-.4-1.7-.1-3.5-.2-5.3,0-1,0-1.9,0-2.9,0-.3.1-.4.4-.4,1.8,0,3.7,0,5.5,0,.3,0,.4,0,.4.4,0,2.4,0,4.8,0,7.3,0,.3-.1.6-.4.9.9,0,1.7,0,2.5,0,.3,0,.3-.2.4-.3,1.3-2.3,2.7-4.5,4.2-6.7.5-.7,1-1.4,1.5-2.1.2-.2.1-.3,0-.5-1-1.3-2.2-2.6-3.3-3.8-.1-.1-.3-.2-.5-.2-2.4,0-4.8,0-7.2,0-.4,0-.5.1-.5.5,0,.6,0,1.2,0,1.9,0,0,0,0,0,0-.1-.6,0-1.3,0-1.9,0-.4-.1-.5-.5-.5-1.7,0-3.5,0-5.2,0-.4,0-.7.1-1,.4-2.9,2.9-5.8,5.8-8.7,8.7-.3.3-.6.6-1.1.7-.5.1-1.1-.1-1.4-.6-.3-.5-.3-.9.1-1.4,1.1-1.2,2.3-2.3,3.5-3.5,1.7-1.7,3.4-3.4,5.2-5,.3-.3.5-.6.3-1-.3-.6-.2-1.2-.2-1.8,0-1.2,0-2.4,0-3.6,0-.3,0-.4-.4-.4-.8,0-1.7,0-2.5,0-.3,0-.3.2-.3.4-.4,1.2-1.7,1.7-2.7,1-.7-.4-.9-1.1-.7-1.9.1-.7.8-1.3,1.5-1.4.8,0,1.6.3,1.8,1,.2.7.6.8,1.2.8,2.9,0,5.8,0,8.7,0,.3,0,.6,0,.9-.3.4-.5,1.1-.7,1.7-.9.6-.2,1.2-.4,1.8-.7-.7.8-.8,1.9-1,2.9-.3,1.2-1.2,1.6-2.3,1.8-.2,0-.5.2-.7,0,0,0-.1-.1-.2-.2ZM41.1,63.5s0,0,0,0c0-1.4,0-2.8,0-4.2,0-.4,0-.5-.5-.5-1.2,0-2.4,0-3.6,0-.2,0-.3,0-.5.2-1.2,1.3-2.2,2.8-3.3,4.2-.1.1-.1.2,0,.4.1.2.3.3.4.5,2.1,2.6,4,5.5,5.7,8.4.2.4.7.6,1.4.4.4-.1.2-.5.3-.7.1-.7-.2-1.6.6-2.1,0,0,0,0,0-.2,0-.4,0-.9,0-1.3,0-.1,0-.3-.1-.2-.7.1-.5-.4-.5-.7,0-1.4,0-2.8,0-4.2ZM38.5,73c0-.2,0-.3-.1-.4-1.7-2.8-3.5-5.5-5.6-8.1-.3-.4-.5,0-.6.1-1.6,2.1-3,4.2-4.4,6.5-.4.6-.7,1.2-1.1,1.9h11.8ZM29.2,58.8c1.1,1.3,2.2,2.5,3.2,3.8.2.2.2,0,.3,0,.9-1.1,1.7-2.3,2.6-3.4.1-.2.2-.3-.1-.3-2,0-3.9,0-6,0ZM46.2,48c-.5-.1-1-.2-1.4-.3-.3,0-.4-.1-.3.3.2.8,0,1.2-.8,1.6-.2,0-.3.2-.3.4-.5.7-1.1,1.2-2,1.1-.4,0-.9.2-1.3.4-.1,0-.2.1,0,.2.2.4,0,.7-.2,1-.2.2,0,.3.2.3.4,0,.8,0,1.1,0,.4,0,.7-.1,1-.5.6-.8,1.3-1.4,2-2.1.7-.8,1.5-1.5,2.2-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c745f0ab-3a98-440c-a683-7cb79d74394f",
    d: "M54.3,11.9c-.2.6-.7.9-1.2,1.3-.2.1-.3.3-.5.4,1.1,1.3,1.5,2.7.7,4.3-1,2.2-3.9,2.9-5.9,1.5-.2-.2-.4-.2-.6,0-1.8,1.7-3.6,3.4-5.5,5-.1.1-.2.2-.2.4.1,2.1,0,4.2,0,6.3,0,2.4,0,4.8,0,7.3,0,1.5,1.1,2.6,2.7,2.6,2.6,0,5.2,0,7.8,0,1,0,1,0,1.3-1,.5-2,1.9-3.3,3.6-4.3,2.2-1.2,4.5-1.4,6.8-.4,2.2.9,3,2.8,2,4.9-.6,1.4-1.6,2.6-3,3.3-.9.5-1.9.6-2.9.2-.6-.2-1.2-.3-1.8-.3-.3,0-.4.1-.4.5,0,1.6,0,3.2,0,4.8,0,.4,0,.6-.6.6-1.4,0-2.8,0-4.2,0-1.8,0-2.9,1.1-2.9,2.9,0,1.1,0,2.1,0,3.2,0,.4.2.5.5.5.9,0,1.7,0,2.6,0,.4,0,.6-.1.7-.4.9-1.8,2.4-2.6,4.4-2.6,2.2,0,4.1,1.8,4.3,4,.2,2.6-1.4,4.6-4,5-2,.3-4.4-.9-5-3.5-.2-.7-.2-1.4,0-2.1,0-.4,0-.4-.3-.4-1,0-2,0-3,0-.3,0-.4,0-.4-.4,0-1.2,0-2.4,0-3.6,0-1.6,1.1-2.7,2.7-2.9,1.5-.2,3,0,4.5,0,.3,0,.5,0,.5-.4,0-1.7,0-3.3,0-5-.4,0-.7.1-1,.2-1.6.3-2.9-.5-3.2-2.1,0-.4-.2-.5-.6-.5-2.7,0-5.4,0-8.1,0-2,0-3.3-1.2-3.3-3.4,0-4.3,0-8.7,0-13.1-1.2,1-2.2,2.1-3.5,3,.7-.7,1.3-1.4,2-2.1,2.2-2.2,4.5-4.4,6.7-6.7.2-.2.3-.4.1-.7-1-1.9-.4-3.9.8-4.9,1.2-1,2.6-1.2,4.1-.7.2,0,.5.2.6.3.3.6.4.2.7,0,.2-.2.3-.4.6-.5-.2.2-.5.5-.7.7,0,0-.2.2,0,.3.1.2.2,0,.3,0,.4-.4.8-.8,1.3-1.1,0,0,.2-.3.3-.2h0ZM60.8,37.2c0-.7-.5-1.2-1.1-1.2-.7,0-1.2.5-1.2,1.2,0,.6.5,1.2,1.1,1.2.7,0,1.2-.5,1.2-1.2ZM62.5,38.1c0,.6.6,1.2,1.2,1.2.6,0,1.2-.6,1.2-1.2,0-.7-.5-1.2-1.2-1.2-.7,0-1.2.5-1.2,1.2ZM56.8,39.6c0-.7-.5-1.2-1.1-1.2-.6,0-1.2.5-1.2,1.2,0,.7.5,1.2,1.2,1.2.7,0,1.1-.5,1.1-1.2ZM54.8,59.1c-.5-1.5-.5-2.9.7-4,1.2-1.1,2.6-1.1,4.2-.5-1.4-1.1-3.4-.9-4.6.4-1.1,1.2-1.2,3.4-.3,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-79eec3e5-e4b1-4fb0-8514-0b804447255c",
    d: "M35.6,12.7c-.3,1.3-.7,2.7-1,4-.2,1.1-.3,2.2-.4,3.3,0,.1,0,.4-.2.4-.3,0-.2-.2-.2-.4-.3-2.4-.6-4.7-1.4-7,0-.2-.1-.4.2-.4.6,0,1-.5,1-1.1,0-.6-.3-1.2-.8-1.5-.5-.2-1,0-1.4.4-.4.4-.5,1.1-.1,1.5.9,1,1,2.3,1.3,3.5.4,1.5.5,3,.7,4.6,0,.3,0,.4-.3.4-1.2,0-1.2,0-1.4-1.2,0-.7-.2-1.4-.5-2.1-.2-.5-.5-.9-.8-1.3-.8-.7-1.5-1.5-2.1-2.4-2.1-3.8.3-8.7,4.6-9.4,4.3-.7,7.4,2.6,7.5,6.5,0,1.8-.7,3.4-2,4.6-1.6,1.3-2,3-2.1,4.9,0,.4-.1.4-.5.4-1.2,0-1.1,0-1.1-1.1.2-2.1.6-4.1,1.2-6.1.1-.4.3-.7.5-1,.4-.5.4-1,.2-1.5-.3-.5-.7-.7-1.2-.7-.6,0-1,.4-1.1.9-.3.8.2,1.5,1.3,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-25900fc7-413b-4e84-bbba-dd29d0a2f5ee",
    d: "M14.4,16.8c.7-2.4,1.9-4.4,4-5.8.3-.2.7-.4,1.2-.3.7,0,1,.5.8,1.1,0,.1,0,.3-.1.4-.6,1.2-.8,2.4-.6,3.7,0,.5-.2.8-.7,1-.6.2-1.2.3-1.9.5.4.2.8.3,1.1.4,1.1.5,1.4,1.1.8,2.2-.3.5-.6,1-.9,1.5-.1.2-.2.2-.4.1-1.2-.3-2.2-.8-2.5-2.2-.1-.5-.3-.9-.6-1.4.2.6.3,1.2.5,1.8,0,.4.4.9-.2,1.1-.4.1-.4-.5-.5-.8-.2-.6-.3-1.2-.7-1.7.1.6.2,1.1.4,1.7.3,1.2-.4,2.1-1,3,0,.1-.2,0-.3,0-.6-.3-1.2-.5-1.8-.8-.8-.4-1-1.1-.6-1.9.2-.5.6-.9,1-1.3-.7.2-1.3.4-1.9.6-.7.2-1,0-1.3-.6-.5-1.1-1.2-2-2.2-2.7-.2-.2-.5-.4-.6-.6-.5-.6-.2-1.3.6-1.4.8-.1,1.5,0,2.3.2,2.1.5,4,1.8,5.2,2.8.1-.3,0-.5-.1-.7-.3-.4-.6-.7-1-.9-.2,0-.3-.2-.2-.4,0,0,0-.2.2-.2.2,0,.3,0,.3.2.2.6.6.9.9,1.4,0,0,.1.2.3.2.1,0,.1-.2.1-.3,0-.5,0-1.1.2-1.6,0-.1,0-.3.2-.4,0,0,.2,0,.3.1.1.2,0,.3-.1.4-.3.5-.3,1-.3,1.5,0,.2,0,.4.3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-94ab15b2-2604-40b1-88d2-ba4ff9d4c9fa",
    d: "M63.2,16.8c.3.2.4.2.7,0,.5-.3,1.1-.3,1.6,0,.5.3.8.7.7,1.3,0,.5.2,1-.3,1.4-.2.2-.3.2-.5,0-.1-.1-.3-.3-.4-.4-.2-.3-.4,0-.5,0-.2.1-.1.3,0,.4,0,0,0,0,.1.1.6.7.6.7,0,1.4-1.9,1.8-3.9,3.6-5.8,5.5-.6.5-.6.5-1.1,0-.7-.8-1.5-1.5-2.1-2.4-.2-.3-.2-.4,0-.7,1.7-1.5,3.4-3.1,5-4.6.4-.4.8-.7,1.2-1.1.3-.3.5-.2.7,0,.2.2.5.4.7.7.2.2.4.1.5,0,.1-.2.3-.3,0-.6-.2-.2-.5-.4-.5-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ecd6b603-5ba2-40b4-b864-43b7b343af87",
    d: "M10.8,42c-.8-.5-1.1-1.3-1.1-2.1,0-.5,0-1.1,0-1.7,0-.3,0-.4-.4-.4-.9,0-1.8,0-2.8,0-.3,0-.4.1-.4.4,0,2,0,4,0,6,0,.3.3.3.4.5.4.3.6.6.4,1.1-.2.5-.7.7-1.2.6-.4-.1-.7-.6-.6-1,0-.3.2-.6.5-.7.3-.1.4-.4.4-.7,0-1.9,0-3.8,0-5.6,0-.3,0-.6-.4-.7-1.2-.6-2.1-1.4-2.3-2.8-.2-1.6,1.1-3.2,2.7-3.2,1.7,0,3.4,0,5.1,0,.2,0,.4,0,.4.3,0,1.7,0,3.4,0,5.1,0,.7-.3.9-1,.9-.5,0-.8.1-.7.7,0,.2,0,.5,0,.7-.1,1.1.2,2,1,2.7,0,0,0,0,0,0ZM7.3,34.3c0-.6-.5-1.1-1-1.1-.6,0-1.1.5-1.1,1,0,.6.5,1.1,1.1,1.1.5,0,1-.5,1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0c8c157d-ce56-4f99-a43e-aef988285fc4",
    d: "M22.5,28.5c-.6,0-1.3,0-1.9,0-.3,0-.4,0-.4.4,0,1.1-.6,1.8-1.6,2.2-.9.4-2.1,0-2.7-.7-.7-.7-.9-1.9-.4-2.8.5-.8,1.2-1.2,2.2-1.3.9,0,1.8.3,2.2,1.2.3.6.6.8,1.3.8,1,0,2,0,3,0,.4,0,.6-.1.5-.6,0-1.1,0-2.2,0-3.3,0-.3,0-.4-.4-.5-1.2-.2-2-1.1-2-2.2,0-1.1.7-2,1.9-2.2,1.1-.2,2.2.5,2.5,1.6.3,1-.3,2.3-1.4,2.6-.4.1-.5.3-.5.7,0,1.1,0,2.2,0,3.4,0,.4-.1.5-.5.5-.6,0-1.2,0-1.9,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-09aadaa6-0025-405c-9311-4051b063a049",
    d: "M4.9,37.8c-1.3,0-2.7,0-4,0-.6,0-.9-.3-.9-.9,0-1.7,0-3.4,0-5.1,0-.4.2-.4.5-.4,1,0,2.1,0,3.1,0,.3,0,.5,0,.8,0-2.4,1.6-2.1,5,.6,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-f3767eb2-330f-4c68-941a-4f9ac1c3f136",
    d: "M64.6,2.4c0,.3-.2.5-.3.6-2.6,2.5-5.2,5-7.7,7.5-.7.7-.7.7-1.3,0-.3-.3-.4-.5,0-.8,2.6-2.4,5.2-4.9,7.8-7.3.2-.2.4-.4.6-.5.2-.2.5-.2.8,0,.2.1.4.3.3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-8bc3196a-45ec-49e3-981d-cadad2686eb6",
    d: "M1.8,26.3c1,.6,1.5,1.5,1.6,2.6,0,.5.2.5.6.5,1.4,0,2.8,0,4.3,0,.2,0,.5,0,.6-.3,0-.3.5-.2.7-.2.2,0,.4,0,.4.2,0,.3.2.3.4.3.2,0,.4,0,.5,0,.5,0,.7.3.7,1,0,.7,0,.7-.7.7-3.4,0-6.8,0-10.2,0-.4,0-.7,0-.7-.5,0-.8.1-1.1.7-1.2.2,0,.5,0,.7,0,.2,0,.3,0,.4-.3.1-.4.5-.2.8-.2.2,0,.4,0,.4.3,0,.2,0,.3.2.2.2,0,.2-.2.2-.3-.1-.8-.3-1.6-.9-2.1-.2-.2-.4-.4-.5-.6h0ZM6.1,30.2s0,0,0,0c-1.3,0-2.6,0-3.8,0-.1,0-.4,0-.4.2,0,.2.2.2.4.2.5,0,1.1,0,1.6,0,1.9,0,3.9,0,5.8,0,.2,0,.6.1.6-.2,0-.4-.4-.2-.6-.2-1.2,0-2.4,0-3.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2244b5c5-2494-43b9-941d-814a3dfba9e1",
    d: "M45.8,33.2c.7-.7.9-1.6,1.1-2.5.2-.8.7-1.4,1.6-1.7.3,0,.4-.2.3-.5,0-1.4,0-2.7,0-4.1,0-.2,0-.4-.2-.5-.2-.2-.2-.4,0-.6.2-.2.3,0,.5,0,.2.2.2.4,0,.6-.2.2-.2.4-.2.6,0,1.3,0,2.7,0,4,0,.3,0,.4.4.4.3,0,.7.1,1,0,.6,0,1.2,0,1.6-.5.4-.4.9-.7,1.2-1.1.3-.5.9-.8,1.3-1.2.3-.3.6-.6,1-.8.1.2.5.6.4.7-.1.2-.3.6-.7.6.1-.1.2-.2.3-.4.1-.1.2-.2,0-.4-.2-.2-.3,0-.4,0-.8.7-1.5,1.4-2.3,2.1-.5.5-1.2.7-1.3,1.4-.9.2-.8,1.2-1.1,1.8-.5,1.1-1.5,1.4-2.6,1.5-.7,0-1.3.1-2,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b34f7937-7384-4db7-acf9-feaf70454b0c",
    d: "M20.2,37.2c0,.2,0,.3.2.4.7.8.5,1.9-.3,2.6-.8.6-1.9.5-2.6-.4,0-.1-.1-.3-.3-.3,0,0,0,0,0,0,.2-.2,0-.5,0-.7.1-1.4,1.5-2.1,2.6-1.6,0,0,.2.2.3,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c3cf1b5a-4c58-4190-9cca-6e5fb3b59ed9",
    d: "M55.3,26.9c.6.5,1,1,.9,1.9,0,.6,0,1.2.1,1.8.4,1.2,1.5,1.9,2.8,1.6,1.2-.2,2-1.3,1.9-2.5,0-.7,0-1.4,0-2.1.1-1.5,1.4-2.7,3-2.6,1.7,0,3.1,1.3,3.1,2.8,0,2.9,0,5.9,0,8.9,0,2.2,0,4.5,0,6.7,0,1.4-.5,2.4-1.8,3-.2,0-.3.2-.4.5-.1.5-.7.7-1.2.5-.4-.2-.6-.7-.4-1.1.2-.4.9-.7,1.3-.3.5.5.9.2,1.2-.1.9-.7,1.1-1.7,1.1-2.8,0-4.9,0-9.7,0-14.6,0-1.8-.9-3-2.6-3.3-1.7-.3-3.3,1-3.3,2.7,0,.7,0,1.4,0,2.1,0,1.3-1.2,2.4-2.6,2.4-1.4,0-2.5-1.1-2.5-2.5,0-.2,0-.4,0-.6,0-.9,0-1.7-.8-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7e8b2f09-ac07-4805-b984-f85d2a7afe29",
    d: "M20.2,61.8s0,0,0,0c.7.1,1.5,0,2.2,0,.6,0,.8.3.6.9,0,.2-.3.1-.4.2-1.2,0-2.3,0-3.5,0-.4,0-.8,0-1.3,0-.6,0-.3-.5-.3-.7,0-.3.2-.3.4-.3.8,0,1.5,0,2.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-bde32d14-df00-4dff-a47d-e75a050fb81e",
    d: "M6,49.6c-.2,0-.4,0-.6,0-.9,0-1.2-.3-1.1-1.3,0-.3.2-.5.5-.5.9,0,1.7,0,2.6,0,.4,0,.5.2.5.5,0,.9-.2,1.2-1.2,1.2-.2,0-.5,0-.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-30a81f88-b04b-46b3-91d0-ceba4cc92336",
    d: "M12.2,7.7c.7,0,1.3.6,1.3,1.2,0,.7-.6,1.3-1.4,1.3-.6,0-1.2-.6-1.2-1.2,0-.7.6-1.3,1.3-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-188423a4-6077-4706-8839-453f936fc847",
    d: "M34,21c.6,0,1.2,0,1.8,0,.4,0,.5.2.5.5,0,.3,0,.6-.4.6-1.2,0-2.4,0-3.7,0-.5,0-.5-.2-.5-.6,0-.3,0-.6.5-.6.6,0,1.2,0,1.8,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7eb793b7-33c1-4cba-8272-bc290752808b",
    d: "M34,22.7c.6,0,1.2,0,1.9,0,.4,0,.5.2.5.5,0,.3,0,.6-.5.6-1.2,0-2.4,0-3.6,0-.4,0-.5-.2-.5-.6,0-.3,0-.6.5-.5.6,0,1.2,0,1.8,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7c28e144-ac5c-4d60-8ec8-536f1dadc472",
    d: "M34,25.4c-.6,0-1.2-.2-1.6-.7-.2-.3-.1-.4.2-.4.9,0,1.9,0,2.8,0,.3,0,.3.2.2.4-.4.6-1,.7-1.6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-daf4052d-cedd-49f1-9ab3-22dfa1f58875",
    d: "M20.2,37.2c.7-.7,1.5-1.3,2.2-2,.4-.4.4-1.3,0-1.7-.6-.6-1.2-1.2-1.8-1.8,0,0,0,0,.1-.1.7.7,1.3,1.4,2,2.1.1.1.2.3.5.2.3-.2.7,0,.9.3.2.3.2.6,0,.8-.2.3-.6.5-.9.3-.4-.2-.6,0-.9.3-.6.6-1.2,1.1-1.8,1.6,0,0-.2.2-.3,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-753e0140-739b-46a2-9323-b3076c1aea73",
    d: "M10.8,41.9c.4.2.8.4,1.2.4.4,0,.7.1,1-.4.2-.5.8-.5,1.2,0,.1.1.2.2.4,0,.9-.8,1.7-1.6,2.6-2.4,0,0,0,0,0,0,.1.3-.1.4-.2.5-.7.7-1.5,1.4-2.2,2-.1.1-.3.3-.3.5,0,.3-.3.5-.6.6-.3,0-.6,0-.8-.3-.2-.3-.4-.3-.7-.3-.6,0-1.1,0-1.6-.5,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d6107f35-9b6f-4976-8a28-05ee50f5a365",
    d: "M32.4,10.5c.5,0,.9.4.9.9,0,.5-.4.8-.9.9-.5,0-.8-.4-.8-.9,0-.4.4-.8.8-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-aa4dcba3-4355-4d66-9aca-7d2d3bd710be",
    d: "M35.5,12.2c-.4,0-.8-.5-.8-.9,0-.5.4-.9.9-.8.4,0,.8.5.8.9,0,.5-.5.9-.9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-750c8bb0-8718-455c-9ec3-de48b119f7e3",
    d: "M17.7,54.3c0,0,.1.1.2.2-.8.7-1.5,1.4-2.3,2.1-.2.2,0,.3,0,.4.1.1.1.2,0,.3-.1.1-.2,0-.2-.1-.5-.4-.8-.9-1.2-1.3,0,0,.1,0,.2,0,.5.5.8,0,1.2-.2.5-.4,1-.9,1.5-1.2-.5.6-1.2,1.1-1.8,1.7-.1.1-.3.2-.1.4.2.2.3,0,.4,0,.6-.6,1.1-1.2,1.7-1.7.2-.2.1-.3-.1-.4.2-.2.3.1.5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1c9d4609-ddfc-4904-adbf-30fa9dfc99ed",
    d: "M1.8,26.4c-.9-.6-1.5-1.5-1.6-2.6,0-.6,0-1.2,0-1.9.3-2.2,2.7-3.5,4.7-2.5.5.2.8.6,1,1.1-.5-.7-1.2-1.1-2.1-1.2-1.5-.2-3.4,1-3.5,2.9,0,.6,0,1.2,0,1.8.1,1.1.8,1.8,1.5,2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-106aa8b9-02b2-42a8-b0bf-4991793e1ca8",
    d: "M40.1,5.3c-.1,0-.2,0-.3-.2,0-.1,0-.2,0-.3.5-.4,1-.9,1.5-1.3.1-.1.2,0,.3,0,.1.1.1.3,0,.4-.5.4-1,.8-1.5,1.3,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-cca3c92e-d836-43c1-b330-4c6ca7b1e8bb",
    d: "M30.7,2.8c0,.2,0,.3-.2.4-.1,0-.2,0-.3-.1-.3-.6-.6-1.1-.9-1.7,0,0,0-.2,0-.3.1,0,.3-.1.4,0,.3.6.7,1.2.9,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c1da040c-4699-43b4-85d0-85d906f35b32",
    d: "M26.5,3.5c0,0,.2,0,.3.2.4.3.8.7,1.2,1,.1.1.3.2.1.5-.2.3-.3,0-.5,0-.4-.4-.9-.7-1.3-1.1-.1-.1-.2-.2,0-.4,0-.1.1-.2.3-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d269df1b-517b-4558-b8d2-ef1165d0c70c",
    d: "M38.6,1.2c0,.1-.1.3-.2.4-.2.4-.4.9-.6,1.3,0,.2-.2.3-.4.2-.2-.1-.2-.3,0-.4.2-.5.5-1,.8-1.5,0-.2.2-.2.4-.1.1,0,.2,0,.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-26a16ce9-aca4-4b3f-80d8-2587efb72666",
    d: "M34.2,1.1c0,.3,0,.6,0,.9,0,.2,0,.3-.2.3-.2,0-.3-.2-.3-.4,0-.6,0-1.2,0-1.8,0-.2,0-.3.2-.3.2,0,.3,0,.3.3,0,.3,0,.6,0,.9,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-33f99234-4a54-446e-a5d3-e7375932db7a",
    d: "M24.5,6.7c.6.2,1.2.4,1.8.7.1,0,.1.2,0,.3,0,.1-.2.2-.3.1-.5-.2-1.1-.5-1.6-.7-.1,0-.2-.1-.1-.3,0-.1.1-.2.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-e2bf9cf0-29eb-46ff-9bc3-f2c67fdd2a84",
    d: "M43.4,14.4c-.1.2-.1.4-.4.3-.5-.3-1-.5-1.5-.8-.1,0-.2-.2-.1-.3,0-.1.1-.3.3-.2.5.3,1.1.5,1.6.8,0,0,0,.1.1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-4171c1f7-8cd5-4339-9dda-80061ccc48fb",
    d: "M26.4,13.6c0,.2,0,.2-.2.3-.5.2-.9.5-1.4.7-.2,0-.3.1-.4,0-.1-.2,0-.3.1-.3.5-.3.9-.5,1.4-.8.2-.1.4,0,.4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9566493d-9a53-456b-b0da-fb3221808e08",
    d: "M43.5,7c0,.2-.1.2-.2.2-.5.2-1,.4-1.5.6-.2.1-.3,0-.4-.1-.1-.2,0-.3.1-.3.5-.3,1-.5,1.5-.6.2,0,.4,0,.4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2d89ed8f-58d6-4899-871e-3af2f7da0362",
    d: "M24.8,10.9c-.4,0-.6,0-.9,0-.2,0-.3,0-.3-.2,0-.2,0-.3.2-.3.6,0,1.1,0,1.7,0,.2,0,.3,0,.3.2,0,.2-.2.2-.3.3-.3,0-.6,0-.8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ed97a815-df58-4080-a3f2-8c8059874e17",
    d: "M43.1,10.9c-.3,0-.6,0-.9,0-.1,0-.3,0-.3-.3,0-.1.1-.2.3-.2.6,0,1.1,0,1.7,0,.1,0,.2,0,.3.2,0,.2-.1.3-.3.3-.3,0-.5,0-.8,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-f5688104-de39-4646-842d-8c80c3698a0e",
    d: "M18.1,63.5h4.3s0,0,0,.1h-4.3s0,0,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-10a73258-05ef-42c9-a530-54ab6e60af0c",
    d: "M61.3,53.7c1-.9,1.4-2.1,1.3-3.4,0-.7-.1-1.4.3-2.1-.4.9-.1,1.9-.2,2.8,0,1.1-.5,2-1.4,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0085a2e1-3cba-4fd8-89ca-050f88866145",
    d: "M11.9,67.5c-.2,0-.4-.1-.4-.4,0-.3.2-.4.4-.4.3,0,.5.1.5.4,0,.2-.2.4-.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-4d517895-a005-407d-b031-03cdfe8d77ea",
    d: "M6.1,9c0,.2-.3.4-.5.4-.2,0-.4-.1-.4-.4,0-.2.2-.4.4-.4.3,0,.4.2.5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1b4efc57-1d6f-4619-9911-e4aba22bf88a",
    d: "M56.4,25.7c-.4-.2-.7-.5-1-.8,0,0,0-.2,0-.2,0,0,.2,0,.3,0,.3.3.5.6.7,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-09d1b8f9-f58a-4355-91b8-2269bf791e46",
    d: "M7,9h3.5s0,0,0,0h-3.6s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-81b53b9c-db86-4995-8d02-1a161cf5b03b",
    d: "M55.3,11.6c-.5,0-.7-.4-.9-.7,0,0,0-.1,0-.2,0,0,.1,0,.2,0,.3.2.5.5.7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1ea5eafc-affa-42c0-a263-415ee0cb447e",
    d: "M54.3,11.9c0-.2-.2-.4,0-.6.3,0,.5.2.5.5,0,.2-.3.2-.5.2h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtandIllustration);
export default __webpack_public_path__ + "static/media/Art and Illustration.2f7153fcf8f85312594b7fa85082de89.svg";
export { ForwardRef as ReactComponent };